// Story 1.21 — live cert preview shown beside the application form.
//
// Epic 8: renders the REAL <PatronageCertificate> artifact (the same
// engraved-parchment share the marketplace/vault show) on the dark
// display inset from the ListingDetail design, live-fed from the form
// fields. Preview conventions: preferred tier (mid-ladder — the actual
// tier is decided at each reveal ceremony), mint condition, and
// placeholders for the fields no applicant has yet — zeroed serial,
// today's date for issued, generic dossier title — so the bottom <dl>
// shows all four rows a real certificate renders. The old Card-based
// stand-in from v1 is retired.

import { PatronageCertificate } from "@greenhold/components";

interface Props {
  displayName: string;
  helloText: string;
  imagePreviewUrl: string | null;
  signaturePreviewUrl: string | null;
}

export function CreatorApplicationCertPreview({
  displayName,
  helloText,
  imagePreviewUrl,
  signaturePreviewUrl,
}: Props) {
  return (
    <div className="sticky top-8 space-y-4">
      <h3 className="text-sm font-semibold uppercase tracking-wider text-brand-forest-700">
        Live certificate preview
      </h3>
      {/* Dark display well (ListingDetail.dc.html): the artifact ground is
          reserved forest-900 with the gold hairline — same presentation as
          a listing's artifact inset on the marketplace. */}
      <div className="flex justify-center rounded-xl border border-brand-gold-500/40 bg-brand-forest-900 px-6 py-8">
        <PatronageCertificate
          width={280}
          tier="preferred"
          name={displayName || "Your Name"}
          serial="GH-0000-0000"
          dossier="New Dossier"
          issued={new Date().toISOString().slice(0, 10)}
          portraitUrl={imagePreviewUrl}
          signatureUrl={signaturePreviewUrl}
          quote={
            helloText ||
            "Your one-line introduction will appear here as you type."
          }
          condition={0}
        />
      </div>
      <p className="font-mono text-xs uppercase tracking-widest opacity-50">
        Preview · tier is decided at each reveal ceremony
      </p>
      <p className="text-sm leading-relaxed opacity-70">
        ↳ This is exactly how your hello-text and image will appear on every
        certificate of you, forever. Updates to your profile later won&apos;t
        change certificates already issued.
      </p>
    </div>
  );
}
